import React, { Suspense, useEffect } from "react";
import "./App.css";
import './assets/css/fonts.css';

import { Navigate, useRoutes } from "react-router-dom";
import { indexRouter } from "./app/routers/indexRouter";
import { ToastContainer } from "react-toastify";
import NotFound from "./app/pages/error/NotFound";
import Cookies from "universal-cookie";
import { AuthConstant } from "./app/constants/authConstant";
import { jwtDecode } from "jwt-decode";
import { WebSocketService } from "./app/services/ws/WebSocketService";

export const spinner = (
  <div className="progress-spinner text-center">
    <div className="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
);
function App() {
  const cookies = new Cookies();
  let token = cookies.get(AuthConstant.ACCESS_TOKEN);
  let router = useRoutes([{ path: "/", element: <Navigate to="/dcs/dcs0101" replace /> }, indexRouter, { path: "err-network", element: <NotFound /> }, { path: "*", element: <NotFound /> }]);

  useEffect(() => {
    if (token) {
      let decodedToken: { userUid: string } = jwtDecode(token);
      let userUid = decodedToken.userUid;
      WebSocketService.getInstance().connectWebSocket(userUid);
    }
  }, [token]);

  return (
    <div>
      <ToastContainer></ToastContainer>
      <Suspense fallback={spinner}>{router}</Suspense>
    </div>
  );
}

export default App;
